import { Select } from '@faceup/ui-base'
import { convertRegionToRegionName, SupportedRegion } from '@faceup/utils'
import useRegion, { DEFAULT_SUPPORTED_REGION } from '../utils/useRegion'

const RegionSelect = () => {
  const { region, setRegion } = useRegion()

  return (
    <Select
      value={region ?? DEFAULT_SUPPORTED_REGION}
      onSelect={newRegion => setRegion(newRegion)}
      style={{ maxWidth: '200px' }}
      options={Object.values(SupportedRegion).map(region => ({
        label: convertRegionToRegionName(region),
        value: region,
      }))}
    />
  )
}

export default RegionSelect
